<div class="dialog-header">
  <div class="dialog-icon-wrapper">
    <div class="dialog-icon new">
      <i class="fa-solid fa-user-shield"></i>
    </div>
    <div>
      <h2 class="dialog-title">Edit Role</h2>
      <p class="dialog-subtitle">Fill in the role details</p>
    </div>
  </div>
  <button class="dialog-close" (click)="onCancel()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <form [formGroup]="roleForm" class="dialog-form-grid">
    <div class="dialog-form-grid-full" style="display: grid; grid-template-columns: 1fr auto; gap: 16px;">
      <!-- Role Name -->
      <div class="dialog-field-group">
        <mat-label class="mat-form-field-label">Role Name <span class="req">*</span></mat-label>
        <mat-form-field appearance="outline">
          <input matInput formControlName="roleName" placeholder="Enter role name">
          @if( roleForm.get('roleName')?.hasError('required') ) {
            <mat-error >Role Name is required</mat-error>
          }
          @if( roleForm.get('roleName')?.hasError('invalidcharacters') ) {
            <mat-error >Role Name contains invalid characters</mat-error>
          }
        </mat-form-field>
      </div>

      <!-- Show to Office Admins Checkbox -->
      <div class="dialog-field-group" style="display: flex; align-items: center; padding-top: 20px;">
        <mat-checkbox formControlName="showToOfficeAdmins">Show to office admins</mat-checkbox>
      </div>
    </div>

    <!-- Privileges Table -->
    <div class="dialog-form-grid-full" >
      <div class="privileges-table-container">
        <div class="table-wrapper">
          <table mat-table [dataSource]="dataSource" matSort>

            <!-- Select Column -->
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="privilegeSelection.hasValue() && isAllSelected()" [indeterminate]="privilegeSelection.hasValue() && !isAllSelected()"></mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? privilegeSelection.toggle(row) : null" [checked]="privilegeSelection.isSelected(row)"></mat-checkbox>
              </td>
            </ng-container>

            <!-- Privilege Column -->
            <ng-container matColumnDef="privilege">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Privilege </th>
              <td mat-cell *matCellDef="let row"> {{row.description}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <button class="btn-ghost" (click)="onCancel()">Cancel</button>
  <button class="btn-blue" (click)="onSubmit()" [disabled]="!roleForm.valid">
    {{(data.id == -1 ? 'Create' : 'Update')}} Role
  </button>
</mat-dialog-actions>
